function ServiceItem({ title, description }) {
    return (
        <div className="service-item">
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
    );
}

export default ServiceItem;